// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HLD_","colBig":"styles_colBig__3fJmZ","colSmall":"styles_colSmall__3QbuQ"};